import React from 'react';
import Card from 'ui/DashboardCard/DashboardCard';
import TransactionHistory from './Blocks/TransactionHistory/TransactionHistory';
import YourAccounts from './Blocks/YourAccounts/YourAccounts';
import Statistics from './Blocks/Statistics/Statistics';
import Beneficiaries from './Blocks/Beneficiaries/Beneficiaries';

import styles from './DashboardPage.module.css';

const DashboardPage = () => (
  <div className={styles.grid}>
    <Card className={styles.yourAccounts}>
      <YourAccounts />
    </Card>
    {/* eslint-disable-next-line css-modules/no-undef-class */}
    <Card className={styles.beneficiaries}>
      <Beneficiaries />
    </Card>
    {/* eslint-disable-next-line css-modules/no-undef-class */}
    <Card className={styles.statistics}>
      <Statistics />
    </Card>
    <Card fullHeight>
      <TransactionHistory />
    </Card>
  </div>
);

export default DashboardPage;
